import { Box, FormLabel, Stack, Typography } from '@mui/material';
import React from 'react';
interface LabelAndValueProps {
  label: string;
  value: string | number | undefined;
  labelWidth?: number;
  valueJustify?: 'end' | 'start' | 'center';
  labelJustify?: 'end' | 'start' | 'center';
  variant?: 'body1' | 'body2' | 'h6' | 'h5' | 'h4' | 'h3' | 'h2' | 'h1';
  alignItems?: 'center' | 'flex-start' | 'flex-end';
}

export function LabelAndValue(props: LabelAndValueProps) {
  const { label, value, labelWidth = 0.5, variant = 'body1', alignItems = 'center' } = props;
  return (
    <Stack direction="row" spacing={3} alignItems={alignItems} sx={{ width: '100%' }}>
      <FormLabel sx={{ width: labelWidth, justifySelf: props.labelJustify }}>{label}</FormLabel>
      <Box sx={{ width: 1 - labelWidth, justifyItems: props.valueJustify }}>
        <Typography variant={props.variant}>{value ?? ''}</Typography>
      </Box>
    </Stack>
  );
}
